export function classNames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    args.forEach(function (arg) {
        switch (typeof arg) {
            case "string":
                classes.push(arg);
                break;
            case "object":
                Object.keys(arg).forEach(function (key) {
                    if (arg[key])
                        classes.push(key);
                });
                break;
        }
    });
    return classes.filter(function (className) { return className !== ""; }).join(" ");
}
